const RegisterPriceByGoodsPluginSettings: IPluginSettings = {
    name: 'Реестровые цены',
    mnemocode: 'register_price_by_goods_plugin',
    permission: 'RegisterPrice',
    columns: [
        {
            order: 0,
            propertyName: 'idGlobal',
            propertyType: 'string',
            displayName: 'ИД',
            sorting: false,
            visibility: false,
            width: 150
        }, {
            order: 1,
            propertyName: 'comment',
            propertyType: 'string',
            displayName: 'Комментарий',
            sorting: false,
            visibility: true,
            width: 150
        }, {
            order: 2,
            propertyName: 'price',
            propertyType: 'number',
            displayName: 'Цена',
            sorting: true,
            visibility: true,
            width: 150
        }, {
            order: 3,
            propertyName: 'isPriceEs',
            propertyType: 'boolean',
            displayName: 'ЕС',
            sorting: false,
            visibility: true,
            width: 150
        }, {
            order: 4,
            propertyName: 'date',
            propertyType: 'datetime',
            displayName: 'Дата регистрации',
            sorting: false,
            visibility: false,
            width: 200
        }, {
            order: 5,
            propertyName: 'dateFrom',
            propertyType: 'datetime',
            displayName: 'Дата с',
            sorting: false,
            visibility: false,
            width: 200
        }, {
            order: 6,
            propertyName: 'dateTo',
            propertyType: 'datetime',
            displayName: 'Дата по',
            sorting: false,
            visibility: false,
            width: 200
        }
    ],
}

export default RegisterPriceByGoodsPluginSettings